import {OfferType} from "@pg-rp/common-types";

import {
    HomeMatchFinancingPreference,
    HomeMatchPreferencesMarketType,
    HomeMatchPreferencesSurveyBuildingHeight,
    HomeMatchPreferencesSurveyPropertyType
} from "../constants/preferences/home_match_preferences_values";
import {HomeMatchSurveyDto, IHomeMatchPreferencesSurveyForm, IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";
import {getHomeMatchFloorsPreferences} from "./home_match_floors_preference";
import {parseRangeBound} from "./parse_range_bound";

const EMPTY_FORM: IHomeMatchPreferencesSurveyForm = {
    additionalExpectations: [],
    area: {},
    buildingHeight: null,
    constructionEndDate: null,
    financing: null,
    floorsPreference: [],
    price: {lower: 0, upper: 0},
    propertyType: null,
    regions: [],
    rooms: null,
    secondaryMarket: false
};

const hasHomeMatchPreferencesSecondaryMarket = (marketTypes: number[] | null | undefined) =>
    marketTypes?.some((marketType) => marketType === HomeMatchPreferencesMarketType.SECONDARY || marketType === HomeMatchPreferencesMarketType.BOTH) ?? false;

export const getHomeMatchPreferencesSurveyMarkets = (marketTypes: number[] | null | undefined) => {
    const hasPrimary = marketTypes?.includes(HomeMatchPreferencesMarketType.PRIMARY) ?? false;
    const hasSecondary = marketTypes?.includes(HomeMatchPreferencesMarketType.SECONDARY) ?? false;
    const hasBoth = marketTypes?.includes(HomeMatchPreferencesMarketType.BOTH) || (hasPrimary && hasSecondary);

    if (hasBoth) return [HomeMatchPreferencesMarketType.PRIMARY, HomeMatchPreferencesMarketType.SECONDARY];

    if (hasSecondary) return [HomeMatchPreferencesMarketType.SECONDARY];

    if (hasPrimary) return [HomeMatchPreferencesMarketType.PRIMARY];

    return [];
};

export const getHomeMatchPreferencesSurveyBuildingHeight = (
    survey: {high_rise_buildings?: boolean | null; low_rise_buildings?: boolean | null} | null | undefined
) => {
    if (survey?.high_rise_buildings) return HomeMatchPreferencesSurveyBuildingHeight.HIGH;

    if (survey?.low_rise_buildings) return HomeMatchPreferencesSurveyBuildingHeight.LOW;

    return null;
};

export const getHomeMatchPreferencesSurveyPropertyType = (types: number[] | null | undefined): HomeMatchPreferencesSurveyPropertyType | null => {
    if (!types?.length) return null;

    if (types.includes(OfferType.FLAT) && !types.includes(OfferType.HOUSE)) return HomeMatchPreferencesSurveyPropertyType.FLAT;

    if (types.includes(OfferType.HOUSE) && !types.includes(OfferType.FLAT)) return HomeMatchPreferencesSurveyPropertyType.HOUSE;

    return null;
};

export const getHomeMatchPreferencesSurveyFormValues = (
    preferences: IHomeMatchUserPreferencesForm | null,
    survey: HomeMatchSurveyDto | null | undefined
): IHomeMatchPreferencesSurveyForm => {
    const financingFromServices = preferences?.financing_services ? HomeMatchFinancingPreference.CREDIT : null;

    return {
        ...EMPTY_FORM,
        additionalExpectations: survey?.additional_areas ?? [],
        area: {
            lower: parseRangeBound(survey?.area?.lower),
            upper: parseRangeBound(survey?.area?.upper)
        },
        buildingHeight: getHomeMatchPreferencesSurveyBuildingHeight(survey),
        constructionEndDate: survey?.construction_end_date ?? null,
        financing: survey?.financing_preference ?? financingFromServices,
        floorsPreference: getHomeMatchFloorsPreferences(survey),
        price: {
            lower: preferences?.price?.lower ?? 0,
            upper: preferences?.price?.upper ?? 0
        },
        propertyType: getHomeMatchPreferencesSurveyPropertyType(survey?.types),
        regions: preferences?.regions ?? [],
        rooms: preferences?.rooms ?? null,
        secondaryMarket: hasHomeMatchPreferencesSecondaryMarket(survey?.market_types)
    };
};
import {OfferType} from "@pg-rp/common-types";

import {
    HomeMatchFinancingPreference,
    HomeMatchPreferencesMarketType,
    HomeMatchPreferencesSurveyBuildingHeight,
    HomeMatchPreferencesSurveyPropertyType
} from "../constants/preferences/home_match_preferences_values";
import {HomeMatchSurveyDto, IHomeMatchPreferencesSurveyForm, IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";
import {getHomeMatchFloorsPreferences} from "./home_match_floors_preference";
import {parseRangeBound} from "./parse_range_bound";

const EMPTY_FORM: IHomeMatchPreferencesSurveyForm = {
    additionalExpectations: [],
    area: {},
    buildingHeight: null,
    constructionEndDate: null,
    financing: null,
    floorsPreference: [],
    price: {lower: 0, upper: 0},
    propertyType: null,
    regions: [],
    rooms: null,
    secondaryMarket: false
};

const hasHomeMatchPreferencesSecondaryMarket = (marketTypes: number[] | null | undefined) =>
    marketTypes?.some((marketType) => marketType === HomeMatchPreferencesMarketType.SECONDARY || marketType === HomeMatchPreferencesMarketType.BOTH) ?? false;

export const getHomeMatchPreferencesSurveyMarkets = (marketTypes: number[] | null | undefined) => {
    const hasPrimary = marketTypes?.includes(HomeMatchPreferencesMarketType.PRIMARY) ?? false;
    const hasSecondary = marketTypes?.includes(HomeMatchPreferencesMarketType.SECONDARY) ?? false;
    const hasBoth = marketTypes?.includes(HomeMatchPreferencesMarketType.BOTH) || (hasPrimary && hasSecondary);

    if (hasBoth) return [HomeMatchPreferencesMarketType.PRIMARY, HomeMatchPreferencesMarketType.SECONDARY];

    if (hasSecondary) return [HomeMatchPreferencesMarketType.SECONDARY];

    if (hasPrimary) return [HomeMatchPreferencesMarketType.PRIMARY];

    return [];
};

export const getHomeMatchPreferencesSurveyBuildingHeight = (
    survey: {high_rise_buildings?: boolean | null; low_rise_buildings?: boolean | null} | null | undefined
) => {
    if (survey?.high_rise_buildings) return HomeMatchPreferencesSurveyBuildingHeight.HIGH;

    if (survey?.low_rise_buildings) return HomeMatchPreferencesSurveyBuildingHeight.LOW;

    return null;
};

export const getHomeMatchPreferencesSurveyPropertyType = (types: number[] | null | undefined): HomeMatchPreferencesSurveyPropertyType | null => {
    if (!types?.length) return null;

    if (types.includes(OfferType.FLAT) && !types.includes(OfferType.HOUSE)) return HomeMatchPreferencesSurveyPropertyType.FLAT;

    if (types.includes(OfferType.HOUSE) && !types.includes(OfferType.FLAT)) return HomeMatchPreferencesSurveyPropertyType.HOUSE;

    return null;
};

export const getHomeMatchPreferencesSurveyFormValues = (
    preferences: IHomeMatchUserPreferencesForm | null,
    survey: HomeMatchSurveyDto | null | undefined
): IHomeMatchPreferencesSurveyForm => {
    const financingFromServices = preferences?.financing_services ? HomeMatchFinancingPreference.CREDIT : null;

    return {
        ...EMPTY_FORM,
        additionalExpectations: survey?.additional_areas ?? [],
        area: {
            lower: parseRangeBound(survey?.area?.lower),
            upper: parseRangeBound(survey?.area?.upper)
        },
        buildingHeight: getHomeMatchPreferencesSurveyBuildingHeight(survey),
        constructionEndDate: survey?.construction_end_date ?? null,
        financing: survey?.financing_preference ?? financingFromServices,
        floorsPreference: getHomeMatchFloorsPreferences(survey),
        price: {
            lower: preferences?.price?.lower ?? 0,
            upper: preferences?.price?.upper ?? 0
        },
        propertyType: getHomeMatchPreferencesSurveyPropertyType(survey?.types),
        regions: preferences?.regions ?? [],
        rooms: preferences?.rooms ?? null,
        secondaryMarket: hasHomeMatchPreferencesSecondaryMarket(survey?.market_types)
    };
};
